'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";

const Lists = ({ordered = false, unstyled = false, inline = false, data = [], className = ""}) => {
    if ( data.length === 0 ) {
        return null;
    }

    const Tag = ordered ? 'ol' : 'ul';

    let items = data.map(function (item, i) {
        return <li key={i}>{item}</li>;
    });

    return (
        <Tag className={classnames(className, {"list-inline": inline}, {"list-unstyled": unstyled})}>
            {items}
        </Tag>
    );
};

Lists.propTypes = {
    ordered: PropTypes.bool,
    unstyled: PropTypes.bool,
    inline: PropTypes.bool,
    data: PropTypes.array.isRequired,
    className: PropTypes.string
};

export default Lists;
